import { PageManager } from '@pst/utils';
import { homePage } from './home';

export function mountPage() {
  new PageManager({
    pages: {
      home: homePage,
    },
  });
}
